import React, {useMemo, useState} from "react";
import './BankAccountSelect.scoped.scss';
import {formatBankAccountNumber} from "../../../../formatters";
import {useAppDispatch, useProfileData} from "../../../../hooks";
import {selectBankAccount} from "../../../../store/profile";
import {cn, resultIf} from "../../../../utils";
import RotatedOpener from "../../../common/utils/RotatedOpener";

const BankAccountSelect = () => {
  const profileData = useProfileData();
  const dispatch = useAppDispatch();
  const availableAccounts = profileData.bankAccounts;
  const [opened, setOpened] = useState(false);

  const toggle = () => {
    setOpened((opened) => !opened);
  };

  const onSelected = (account: string) => {
    dispatch(selectBankAccount(account));
  };

  const renderAccounts = useMemo(() => {
    return availableAccounts.map((account) => {
      return <li
        onClick={() => onSelected(account)}
        key={account}
        className="bank-account-select__element"
      >
        { formatBankAccountNumber(account) }
      </li>;
    });
  }, [availableAccounts]);

  return (
    <div
      className="bank-account-select"
      onClick={toggle}
    >
      <div className="bank-account-select__number">
        { formatBankAccountNumber(profileData.selectedBankAccount) }
      </div>
      <RotatedOpener active={opened} />
      <div
        className={cn(
          "bank-account-select__dropdown",
          resultIf(opened, "active")
        )}
      >
        <ul className="bank-account-select__list">
          { renderAccounts }
        </ul>
      </div>
    </div>
  );
};

export default BankAccountSelect;